import * as React from "react";
import styled from "styled-components";
import theme from "themes/simple-theme";

export interface IProps {
  className?: string;

  isActive: boolean;
  label: string;
  onClick?(label: string): void;
}

const Tab = styled(({ className, label, onClick }: IProps) => {
  const handleClick = (event: any) => {
    event.preventDefault();
    if (onClick) {
      onClick(label);
    }
  };
  return (
    <li className={className} onClick={handleClick}>
      <a>{label}</a>
    </li>
  );
})`
  box-sizing: border-box;
  color: ${theme.color.primary}
  height: 70px;
  padding: 0px 24px;
  cursor: pointer;
  font-family: ${theme.fontFamily.bold};
  text-transform: uppercase;
  line-height: 70px;
  ${({ isActive }: IProps) =>
    isActive
      ? `
      cursor: auto;
    border-bottom: 2px solid ${theme.color.primary};
  `
      : ``};
`;

export default Tab;



// WEBPACK FOOTER //
// ./src/components/Tabs/tab.tsx